import React from 'react';
import quantumLogo from '../../../assets/images/quantum_16.svg';

function CPLogo() {
    return (
        <div>
            <div style={{ display: "table-cell" }}>
                <img style={{ width: 24, height: 24, paddingTop: '2px' }} src={quantumLogo} alt="Checkpoint" />
            </div>
            <div className="SMCMainHeaderLogoText">
                <small style={{ fontSize: 10, lineHeight: "10px" }}>Quantum Spark</small>
                <br />
                Security Management Portal
            </div>
        </div>
    );
}

export default CPLogo;